import * as yup from 'yup';
import dayjs from 'dayjs';

export const CaptainUpdateConf = {
    schema: {    
        username: yup.string().nullable(),
        email: yup
            .string()
            .nullable(),
        birthdate: yup
            .date()
            .nullable()
            .transform((value) => {
                if (value && dayjs(value).isValid()) {
                    return value;
                }
                return null;
            }).required('Birthdate is required'),
    },
    defaultValues: {
        username: '',
        email: '',
        birthdate: null,
    },
    fields: [
        	{
			id: 'username',
			name: 'username',
			type: 'text',
			label: 'Username',
			xs: 12,
			sm: 6,
            disabled:true,
		},
		{
			id: 'email',
			name: 'email',
			type: 'text',
			label: 'Email',
			xs: 12,
			sm: 6,
            disabled:true,
		},
        {
            id: 'birthdate',
            name: 'birthdate',
            type: 'date',
            label: 'Birthdate',
            required: true,
            xs: 12,
            sm: 6,
        },
    ],
};
